/**
 * Task Template Components
 *
 * Registry pattern for extensible task templates by actionType.
 * Add new action types here to extend the template system.
 *
 * @module pages/tasks/components/templates
 */

import type { FC } from 'react';
import type { TaskTemplateProps } from '../../types';
import { DefaultTaskTemplate } from './DefaultTaskTemplate';
import { ViewPhotoTaskTemplate } from './ViewPhotoTaskTemplate';
import { CommentOnPhotoTaskTemplate } from './CommentOnPhotoTaskTemplate';
import { ReplyToCommentTaskTemplate } from './ReplyToCommentTaskTemplate';
import { CommentOnNPhotosTaskTemplate } from './CommentOnNPhotosTaskTemplate';

/**
 * Task Template Registry - maps actionType to template component
 * Add new action types here to extend the template system
 */
export const TASK_TEMPLATE_REGISTRY: Record<string, FC<TaskTemplateProps>> = {
  VIEW_PHOTO: ViewPhotoTaskTemplate,
  COMMENT_ON_PHOTO: CommentOnPhotoTaskTemplate,
  REPLY_TO_COMMENT: ReplyToCommentTaskTemplate,
  COMMENT_ON_N_PHOTOS: CommentOnNPhotosTaskTemplate,  // Feature 651
  // RATE_PHOTO: RatePhotoTaskTemplate,  // TODO: Add when needed
  MANUAL: DefaultTaskTemplate,
};

/**
 * Get the appropriate template component for a task's action type
 */
export function getTaskTemplateComponent(actionType: string): FC<TaskTemplateProps> {
  return TASK_TEMPLATE_REGISTRY[actionType] || DefaultTaskTemplate;
}

// Re-export individual components for direct use if needed
export { TaskActions } from './TaskActions';
export { DefaultTaskTemplate } from './DefaultTaskTemplate';
export { ViewPhotoTaskTemplate } from './ViewPhotoTaskTemplate';
export { CommentOnPhotoTaskTemplate } from './CommentOnPhotoTaskTemplate';
export { ReplyToCommentTaskTemplate } from './ReplyToCommentTaskTemplate';
export { CommentOnNPhotosTaskTemplate } from './CommentOnNPhotosTaskTemplate';
